// config of fields to set in the datalayer
// first level is the event name
// second level is source for the event type, named eventTypeSource and the gtmEventName (name of event sent to iframe)
// At third level below trackingFieldNames we find the data/hidden configs for the different events
//   hidden: array of event specific attributes to add to the event
//   data: general data to add to the event
//
// If event is not in here, we just send the event including all extra data to GTM.
export const HIDDEN_FIELDS_CONFIG = {
	stateUpdate: {
		eventTypeSource: "stateOf",
		gtmEventName: "stateUpdate",
		trackingFieldNames: {
			default: {
				data: ["stateOf"],
			},
			cart: {
				data: ["stateOf"],
				hidden: ["articles", "totalArticleValue"],
			},
			submittedOrder: {
				data: ["stateOf"],
				hidden: ["articles", "submitId", "orderAmount", "orderTax", "shippingCosts"],
			},
			cid: {
				data: ["stateOf"],
				hidden: ["cid"],
			},
			icid: {
				data: ["stateOf"],
				hidden: ["icid"],
			},
		},
	},
	"article.adwords": {
		eventTypeSource: "default",
		gtmEventName: "article.adwords",
		trackingFieldNames: {
			default: {
				data: [],
				hidden: ["articles"],
			},
		},
	},
};
